<template>
    <div v-if="user" class="page-wrapper">
        <page-header :title="$t('signup.title')" />
        <ion-text class="header-text w-100" color="medium">{{ $t('signup.uploadImages') }}</ion-text>
        <ion-text class="w-100" color="dark">
            <b>{{ $t('signup.presentYourself') }}</b>
        </ion-text>
        <ion-grid>
            <ion-row>
                <ion-col size="6" size-xl="3">
                    <uploader
                        path="/profile-picture"
                        :defaultImgPath="user && user.images && user.images[0] && user.images[0].path"
                        position="0"
                    />
                </ion-col>
                <ion-col size="6" size-xl="3">
                    <uploader path="/profile-picture" position="1" />
                </ion-col>
                <ion-col size="6" size-xl="3">
                    <uploader path="/profile-picture" position="2" />
                </ion-col>
                <ion-col size="6" size-xl="3">
                    <uploader path="/profile-picture" position="3" />
                </ion-col>
            </ion-row>
        </ion-grid>
        <ion-row v-if="isMobile">
            <ion-button class="back-button" href="/register/step-2" strong>
                <img class="back-arrow icon-img-xs" src="@/assets/icon-images/arrow-left-white.png" />
                {{ $t('master.back') }}
            </ion-button>
        </ion-row>
        <ion-row class="ion-justify-content-center">
            <router-link to="/user/me">
                <ion-button class="signup-button" strong>{{ $t('master.signup') }}</ion-button>
            </router-link>
        </ion-row>
    </div>
</template>

<script>
import Uploader from '@/components/Uploader'
import PageHeader from '@/components/PageHeader'
import { mapGetters } from 'vuex'
import { isMobile } from 'mobile-device-detect'

export default {
    name: 'RegisterThree',
    components: {
        Uploader,
        PageHeader
    },
    data() {
        return {
            isMobile
        }
    },
    computed: mapGetters(['user'])
}
</script>

<style lang="scss" scoped>
.back-button {
    --background: #7cc18b;
    height: 35px;
    padding-left: 15px;
    --border-radius: 20px;
    margin-top: 30px;
    --color: #000000;
}

.signup-button {
    --background: #228f6f;
    width: 250px;
    --border-radius: 20px;
    margin-top: 20px;
}

.w-100 {
    width: 100%;
    max-width: 100%;
    display: inline-block;
}

#app[dir='rtl'] .back-arrow {
    transform: rotate(180deg);
}

@media (min-width: 768px) {
    .page-wrapper {
        width: 80%;
        margin: 0 10%;

        ion-text {
            font-size: 20px;

            .header-text {
                margin-top: 22px;
            }
        }

        ion-grid {
            width: 70%;

            ion-row {
                margin-top: 15px;
            }
        }

        .signup-button {
            font-size: 20px;
            --border-radius: 30px;
            margin-top: 8vh;
        }
    }
}
</style>
